module.exports = __webpack_public_path__ + "static/media/frog(5).14aa3423.PNG";